<script lang="ts">
const __DsBlock = {
	hidden: true,
}
</script>
<script lang="ts" setup>
import type { TranslationPlaceholder } from '#layers/i18n/public';
import type { BadgeProps } from '#layers/ui/public';
import { defineBlock } from '#layers/block-engine/public';
import { useTranslationUtils } from '#layers/i18n/public';

defineProps<{
	label?: TranslationPlaceholder;
	description?: TranslationPlaceholder;
	line?: false | 'above' | 'below';
	size?: 'md' | 'lg';
	badge?: BadgeProps;
}>();

;

const { translateString } = useTranslationUtils();
</script>

<template>
	<DFormSeparator
		:label="translateString(label)"
		:description="translateString(description)"
		:line
		:size
		:badge
	/>
</template>
